import React from "react";
import { X } from "lucide-react";
import { toast } from "react-toastify";

const UpdateUserModal = ({
  isOpen,
  onClose,
  onUpdateUser,
  userToUpdate,
  setUserToUpdate,
}) => {
  const [loading, setLoading] = React.useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserToUpdate((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setUserToUpdate((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userToUpdate.name || !userToUpdate.email || !userToUpdate.telephone) {
      toast.error("Veuillez remplir tous les champs obligatoires");
      return;
    }

    // const phoneRegex =
    //   /^(?:\+\d{1,3}\s?)?(?:\(\d{1,4}\)\s?)?(?:[0-9][\s-]?){8,14}$/;
    // if (!phoneRegex.test(userToUpdate.telephone)) {
    //   toast.error(
    //     "Le numéro de téléphone doit être un format valide (ex: 0609062078 ou +1 (720) 352-7832)"
    //   );
    //   return;
    // }

    setLoading(true);

    try {
      await onUpdateUser();
      toast.success("Utilisateur mis à jour avec succès");
    } catch (error) {
      toast.error("Erreur lors de la mise à jour de l'utilisateur");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold">Modifier l'utilisateur</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nom complet *
            </label>
            <input
              type="text"
              name="name"
              value={userToUpdate.name}
              onChange={handleInputChange}
              placeholder="Entrez le nom complet"
              className="w-full p-3 border rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email *
            </label>
            <input
              type="email"
              name="email"
              value={userToUpdate.email}
              onChange={handleInputChange}
              placeholder="exemple@email.com"
              className="w-full p-3 border rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Téléphone *
            </label>
            <input
              type="tel"
              name="telephone"
              value={userToUpdate.telephone}
              onChange={handleInputChange}
              placeholder="0612345678"
              className="w-full p-3 border rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent"
              required
            />
          </div>

          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              name="isAdmin"
              id="isAdmin"
              checked={userToUpdate.isAdmin}
              onChange={handleCheckboxChange}
              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
            />
            <label
              htmlFor="isAdmin"
              className="text-sm font-medium text-gray-700"
            >
              Compte administrateur
            </label>
          </div>

          <div className="mt-6 flex justify-end space-x-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
              disabled={loading}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50"
              disabled={loading}
            >
              {loading ? "Mise à jour..." : "Mettre à jour"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateUserModal;
